import { Controller } from "@hotwired/stimulus"

// This Stimulus controller manages a menu's open/close state.
// When the menu is opened, it listens for clicks outside to close it.

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
  }

  get menuOpen() {
    return this.element.getAttribute("aria-expanded") === "true"
  }

  set menuOpen(value) {
    const open = value ? "true" : "false"
    this.element.setAttribute("aria-expanded", open)
    this.menuTarget.setAttribute("aria-expanded", open)

    if (value) {
      window.addEventListener("click", this.boundCloseOnClickOutside)
    } else {
      window.removeEventListener("click", this.boundCloseOnClickOutside)
    }
  }

  toggleMenuOpen() {
    this.menuOpen = !this.menuOpen
  }

  closeOnClickOutside(event) {
    console.log("closeOnClickOutside", event.target, this.element)
    const clickInside = this.element.contains(event.target)

    if (!clickInside) {
      this.menuOpen = false
    }
  }
}
